export default __webpack_public_path__ + "static/media/goshen97.b3d6e47a.jpg";